<template>
  <div>
    <div class="container-fluid container-froDesk">
      <div class="wrapper">
        <div class="content-page content-froDesk">
          <div class="content">
            <div class="row">
              <!-- 课题通知 -->
              <div class="col-lg-5">
                <div id="card-left-1" class="card">
                  <div class="card-body">
                    <div class="dropdown float-right">
                      <div class="dropdown-toggle arrow-none" title="更多" @click="toPublicList(17)">
                        <i class="mdi mdi-chevron-right-box-outline"></i>
                      </div>
                    </div>
                    <h3 class="header-title froDeskHeader-tit mb-3 pb-2">
                      <span class="tit">课题通知</span>
                      <span class="ml-1">Subject Notice</span>
                    </h3>
                    <ul class="froDesk-Lists" style="min-height: 229px;">
                      <li class="li_1" v-for="item in noticeList" :key="item.id" @click="toDetailPage(item.id)">
                        <i class="mdi mdi-arrow-right"></i>
                        <a>{{item.title}}</a>
                        <span class="time">{{item.createTime?item.createTime.substring(5,10):''}}</span>
                      </li>
                    </ul>
                  </div> <!-- end card-body-->
                </div> <!-- end card-->
              </div>
              <!-- end 课题通知-->
              <!-- 课题申报 -->
              <div class="col-lg-7">
                <div id="card-right-1" class="card">
                  <div class="card-body">
                    <div class="dropdown float-right">
                      <div class="dropdown-toggle arrow-none" title="更多" @click="toSubjectResearchList">
                        <i class="mdi mdi-chevron-right-box-outline"></i>
                      </div>
                    </div>
                    <h3 class="header-title froDeskHeader-tit mb-3 pb-2">
                      <span class="tit">课题申报</span>
                      <span class="ml-1">Subject Declare</span>
                    </h3>
                    <ul class="froDesk-Lists" style="min-height: 229px;">
                      <li class="li_2" v-for="item in projectList" :key="item.id" @click="toSubjectResearchDetail(item)">
                        <i class="mdi mdi-arrow-right"></i>
                        <a>{{item.projectName}}</a>
                        <span class="time">截止：{{item.declareEndTime?item.declareEndTime.substring(0,16):''}}</span>
                        <span v-if="new Date().getTime()>new Date(item.declareEndTime).getTime()" class="status font-weight-bold text-danger">已截止</span>
                        <span v-else class="status font-weight-bold text-success">进行中</span>
                      </li>
                    </ul>
                  </div> <!-- end card-body-->
                </div> <!-- end card-->
              </div>
              <!-- end 课题申报-->
            </div>
            <div class="row">
              <!-- 在研课题 -->
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-body" style="min-height: 430px;">
                    <div class="dropdown float-right"></div>
                    <h3 class="header-title froDeskHeader-tit mb-3 pb-2">
                      <span class="tit">在研课题</span>
                      <span class="ml-1">Research Subject</span>
                    </h3>
                    <!-- 筛选top -->
                    <div class="conditionTop mt-n2 clearfix">
                      <div class="conditionLeft">
                        <form>
                          <div class="form-row ml-0 mr-0">
                            <div class="form-row ml-0 mr-0 pt-2">
                              <div class="form-group">
                                <el-date-picker v-model="query.date" value-format='yyyy' type="year" placeholder="请选择立项年度">
                                </el-date-picker>
                              </div>
                              <div class="form-group">
                                <el-input v-model="query.name" placeholder="输入名称、单位或负责人"></el-input>
                              </div>
                              <div class="form-group">
                                <button type="button" class="btn btn-success form-control" @click="handleSearch">查询</button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="table-responsive">
                      <table id="proApp-datatable" class="table table-hover table-bordered table-centered table-proApp">
                        <thead>
                          <tr>
                            <th class="text-center">课题名称</th>
                            <th class="text-center">课题编号</th>
                            <!-- <th class="text-center">课题级别</th> -->
                            <th class="text-center">课题类别</th>
                            <th class="text-center">立项年度</th>
                            <th class="text-center">承担单位</th>
                            <th class="text-center">负责人</th>
                            <th class="text-center">阶段</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in list" :key="item.id">
                            <td class="text-center" style="width: 250px;">
															<div class="ellipsis" style="width: 250px;">
															{{item.name}}
															</div>
														</td>
                            <td class="text-center">{{item.classNun}}</td>
                            <!-- <td class="text-center">{{item.classLever}}</td> -->
                            <td class="text-center">{{item.projectTypeName}}</td>
                            <td class="text-center">{{item.lxTime}}</td>
                            <td class="text-center" style="width: 250px;">
															<div class="ellipsis" style="width: 250px;">
																{{item.unitName}}
															</div>
															
														</td>
                            <td class="text-center">{{item.oneEmceeName}}</td>
                            <td class="text-center">{{item.type | getTheTopicUnderStudyPhase}}</td>
                          </tr>
                        </tbody>
                      </table>
                      <el-pagination :hide-on-single-page="true" :page-size="query.pageSize" layout="prev, pager, next" :total="total" @current-change="handlePageChange">
                      </el-pagination>
                    </div>
                  </div> <!-- end card-body-->
                </div> <!-- end card-->
              </div>
              <!-- end 在研课题-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getResearchTopicsList,
  getProjectList1,
  getColumnList,
} from "@/api/before/home";
export default {
  name: "subjectResearch",
  components: {},
  data() {
    return {
      query: {
        date: "",
        name: "",
        projectId: 0,
        pageNumber: 1,
        pageSize: 12,
        pageSorts: [{ asc: true, column: "" }],
      },
      list: [],
      total: 0,
      noticeList: [],
      projectList: [],
    };
  },
  mounted() {
    this.getData();
    this.getColumnList();
    this.getProjectList();
  },
  methods: {
    getData() {
      getResearchTopicsList(this.query).then((res) => {
        if (res.code == 200) {
					console.log('在研课题列表',res);
          this.list = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getColumnList() {
      let query = {
        id: 17,
        pageNumber: 1,
        pageSize: 8,
        pageSorts: [{ asc: true, column: "" }],
      };
      getColumnList(query).then((res) => {
        if (res.code == 200) {
          this.noticeList = res.data.records;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getProjectList() {
      let queryProject = {
        pageNumber: 1,
        pageSize: 8,
        pageSorts: [{ asc: true, column: "" }],
      };
      getProjectList1(queryProject).then((res) => {
        if (res.code == 200) {
          this.projectList = res.data.records;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    handleSearch() {
      this.query.pageNumber = 1;
      this.getData();
    },
    toPublicList(type) {
      this.$router.push("/publicList/" + type);
    },
    toDetailPage(id) {
      this.$router.push("/publicDetails/" + id);
    },
    //去课题申报列表
    toSubjectResearchList() {
      this.$router.push("/subjectResearchList");
    },
    //去课题申报详情
    toSubjectResearchDetail(data) {
      this.$router.push({
        path: "/subjectResearchDetail",
        // query: { data: JSON.stringify(data) },
        query: { id: data.id },
      });
    },
    // 分页导航
    handlePageChange(val) {
      this.query.pageNumber = val;
      this.getData();
    },
  },
};
</script>
<style>
/* 分页器样式 */
.el-pagination {
  text-align: right;
}
.el-pager li {
  margin: 0 4px;
  padding: 0;
  font-size: 13px;
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  box-sizing: border-box;
}
.el-pager li.active {
  color: #fff;
  background-color: #727cf5;
  border-color: #727cf5;
  border-radius: 50%;
}
.el-pager li.active:hover {
  color: #fff;
  background-color: #727cf5;
  border-color: #727cf5;
}
.el-pager li:hover {
  color: #313a46;
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
  border-radius: 50%;
}
.inbox-resNews .inbox-item .inbox-item-img img {
  width: 100%;
}
</style>
<style lang="scss" scoped>
</style>